















import { Vue, Component } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import { InstituteInfo } from "../../_models/instituteInfo";
import { UserInfo } from "../../_models/userInfo";
import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
import { EnterpriseInfo } from "../../_models/enterpriseInfo";
import * as temp from "../../_store/temp.module"

@Component({
  components: {
    CardTitle,
    DetailsDataTable
  }
})
export default class GestioneAlternanzaAzienda extends Vue {
  private titleParams: object;
  private dataTableParams: any;
  private createDialogParams: object;

  private listaPreAssegnazioni: any;
  private listaTutor: any;

  constructor() {
    super();
    this.titleParams = {
      title: "FSL Estiva",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParams = {
      headers: [
        {
          text: "Allievo",
          value: "allievo"
        },
        {
          text: "Classe",
          value: "classe"
        },
        {
          text: "Data Inizio",
          value: "dataInizioPeriodo"
        },
        {
          text: "Data Fine",
          value: "dataFinePeriodo"
        },
        {
          text: "Dettagli Allievo",
          value: "action",
          sortable: false
        },
        {
          text: "Conferma Abbinamento",
          value: "confermaAssegnazione",
          sortable: false
        },
        {
          text: "Dettagli FSL",
          value: "dettagliAlternanza",
          sortable: false
        },
        {
          text: "Documenti",
          value: "dettagliDocAlternanzaAzienda",
          sortable: false
        },
        // {
        //   text: "Report Visita",
        //   value: "report",
        //   sortable: false
        // }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI ALLIEVO",
        type: "userTab"
      },
      filterType: "listaAbbinamenti",
      alternanzaDialogParams: {
        title: "DETTAGLI FSL",
        type: "infoAlternanzaTab"
      },
      type: "alternanza"
    };
    this.createDialogParams = {
      visible: false,
      type: ""
    };
    this.listaPreAssegnazioni = [];
    this.listaTutor = [];
  }

  loadPreAssegnazioni(idAnnoScolastico: number) {
    // var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
    // var userInfo: UserInfo = user.readUserInfo(this["$store"])
    console.log("Caricamento pre-assegnazioni per anno scolastico:", idAnnoScolastico);
    var enterpriseInfo: EnterpriseInfo = user.readEnterpriseInfo(
      this["$store"]
    );
    var payload = {
      idAnnoScolastico: idAnnoScolastico,
      idAzienda: enterpriseInfo.idAzienda
    };
    data
      .dispatchAllieviAssegnatiAzienda(this["$store"], payload)
      .then(result => {
        console.log(result);
        this.listaPreAssegnazioni = result;
        this.dataTableParams.records = result;
        bus.$emit("dataLoaded");
      })
      .catch(error => {
        console.error("Errore nel caricamento delle pre-assegnazioni:", error);
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  loadTutor() {
    var enterpriseInfo: EnterpriseInfo = user.readEnterpriseInfo(
      this["$store"]
    );
    var payload = {
      idAzienda: enterpriseInfo.idAzienda
    };
    data
      .dispatchTutorAzienda(this["$store"], payload)
      .then(result => {
        this.listaTutor = result;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetEnterpriseInfo(this["$store"])
          .then(() => {
            this.loadPreAssegnazioni(idAnnoScolastico);
            // this.loadTutor()
            bus.$emit("loadMenu");
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

      bus.$on("loadPreAssegnazioni", () =>{
        this.loadPreAssegnazioni(idAnnoScolastico)
      })

      bus.$on("changeAnnoScolastico", (payload:any) =>{
        this.loadPreAssegnazioni(payload)
      })
  }
}
